import { Breadcrumb } from 'antd';
import { LayoutCMS } from 'components';
import React from 'react';
import { Link } from 'react-router-dom';
import TablePosts from './libraries';

export const PageTopicsComponent = (props: any) => {
    const title = 'Topics';
    const layoutCMSProps = {
        breadcrumb: (
            <>
                <Breadcrumb.Item>
                    <Link to="/article/topics">Topics</Link>
                </Breadcrumb.Item>
            </>
        ),
        documentTitle: title,
        history: props.history,
        pageTitle: title,
    };
    return (
        <LayoutCMS {...layoutCMSProps}>
            <TablePosts />
        </LayoutCMS>
    );
};

export default PageTopicsComponent;



// WEBPACK FOOTER //
// ./src/pages/topics/component.tsx